import { 
  LOAD_ROLE_DATA_IN_PROGRESS,
  LOAD_ROLE_DATA_SUCCESS,
  LOAD_ROLE_DATA_FAILURE,
  OPEN_ROLE_DIALOG,
  CLOSE_ROLE_DIALOG,
  ROLE_OPERATION_COMPLETED
} from "./actions";

const initialState = { isLoading: false, roleListData: [], isRoleDialogOpen:false};

export const roleData= (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    
    case LOAD_ROLE_DATA_SUCCESS: {
      const { data } = payload;
      return {
        ...state,
        isLoading: false,
        roleListData: data,
      };
    }
    case LOAD_ROLE_DATA_IN_PROGRESS:
      return {
        ...state,
        isLoading: true,
      };
    case LOAD_ROLE_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
      };
      case ROLE_OPERATION_COMPLETED:
        return {
            ...state,
            isLoading: false,
        }; 

        case OPEN_ROLE_DIALOG:
        return {
            ...state,
            isRoleDialogOpen: true,
        }; 

        case CLOSE_ROLE_DIALOG:
        return {
          ...state,
          isRoleDialogOpen: false,
        }; 
    default:
      return state;
  }
};
